import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { escapeRegExp } from "lodash";
import { map } from "rxjs/operators";

import { Observable ,  ReplaySubject } from "rxjs";

import { NSFormFields, NSHttpClient } from "../types";
import { ResponseService } from "./response.service";

const cache: { [key: string]: ReplaySubject<any> } = {};

@Injectable()
export class LocalAssetRequestService {
    public requestInProgress: any;

    constructor(
        public http: HttpClient,
        public response: ResponseService,
    ) { }

    public getJsonFile(path, params?): Observable<NSHttpClient.APIResponse<NSFormFields.IOptionsState>> {

        if (!cache[path]) {
            cache[path] = new ReplaySubject();
            this.http.get(path, {}).pipe(
                map(this.response.formatResponseBody))
                .subscribe((data) => {
                    cache[path].next(data);
                });
        }

        let observable: Observable<any> = cache[path];

        if (this.paramsContainsCategory(params)) {
            observable = this.filterByCategory(observable, params.category);
        }

        if (this.paramsContainsSearchText(params)) {
            observable = this.filterBySearchText(observable, escapeRegExp(params.searchText));
        }

        return observable;

    }

    public filterByCategory(observable, category): Observable<NSHttpClient.APIResponse<NSFormFields.IOptionsState>> {
        return observable.map((res) => {
            if (!!category) {
                const data = res.data.filter((datum) => datum.categories.findIndex((cat) => cat === category) !== -1);
                return { data };
            } else {
                return res;
            }
        });
    }

    public filterBySearchText(observable, searchText): Observable<NSHttpClient.APIResponse<NSFormFields.IOptionsState>> {
        return observable.map((res) => {
            if (!!searchText) {
                return { data: res.data.filter((datum) => !!datum.name.toLowerCase().match(searchText.toLowerCase())) };
            } else {
                return res;
            }
        });
    }

    public paramsContainsCategory(params): boolean {
        return !!params && !!params.category;
    }

    public paramsContainsSearchText(params): boolean {
        return !!params && !!params.searchText;
    }
}
